import { gql } from '@apollo/client'

export const LOCATION = gql`
  query Location($id: ID!) {
    location(id: $id) {
      bookingLogoUrl
      city
      id
      name
      phoneNumber
      state
      street
      timezone
      zip
      displayName
      practice {
        name
        patientSexOptions
        isPatientSexRequired
        bookingFormConfig {
          isPatientInsuranceInfoRequired
          isPatientCommentRequired
          showCareCreditPromo
          customTermsAddendum
        }
      }
      providers {
        id
        name
      }
    }
  }
`

export const PARTNER = gql`
  query Partner($partnerId: ID!) {
    partner(id: $partnerId) {
      disableCareCreditAds
    }
  }
`
